import { ColorGenerator } from '../color-generator/color-generator.class';

export class StaffGraph {

    uid: number;
    name: string;
    grossSales: string;
    itemsSold: string;
    net: string;
    vat: string;
    cost: string;
    discounts: string;
    revenueMargin: string;
    backgroundColor: string;
    model: boolean;
    class: string;
    type: string;
    tagId: number;
    productId: number;
    visible: boolean;

  constructor(data: any) {
    if (data) {
        this.tagId = Number(data.tag_uid);
        this.uid = Number(data.account_uid);
        this.productId = Number(data.product_uid);
        this.name = data.account_name;
        this.grossSales = data.gross_sales;
        this.itemsSold = data.items_sold;
        this.net = data.net;
        this.vat = data.vat;
        this.cost = data.cost;
        this.discounts = data.discount;
        this.revenueMargin = data.revenue_margin;
        const n = Math.random().toString(36).substring(7);
        this.type = 'staff';
        const randomString = this.name + ' ' + n;
        this.backgroundColor = new ColorGenerator().stringToColour(randomString);
        this.visible = false;
    }
  }

  set setVisible(val: boolean) {
    this.visible = val;
  }
}
